import { jwt_decode } from 'jwt-decode';
import { catchError, tap } from 'rxjs/operators';
import { ControlPanelStateDefault, ControlPanelState } from './control-panel.state';
import { State, StateContext, Action, Selector, Store } from '@ngxs/store';
import { ControlPanel } from './control-panel.actions';
import { NotificationService, TypeMessage } from '../core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs/internal/observable/of';
import { Navigate } from '@ngxs/router-plugin';
import { EventEmitter, Injectable } from '@angular/core';
import { CodePostalDto, PanelSection, CategorieDocumentDto, ParametresAzureDto, ParametresEmailDto, ParametresGlobauxDto, ParametresGoogleDto, ParcDto, PaysDto, PictogrammeDto, TypeConteneurMobileDto, TypeDechetDto, TypeDechetRwdto, TypeIncidentDto, UniteMesureDto, ZoneGeographiqueDto, TypeAccesPersonneMoraleDto, FormeJuridiqueDto, ConteneurDto, ExutoireDto, TransporteurDto, DispatchExutoireDto, DispatchTransporteurDto, ParcDetailsDto, EmplacementStockDto, TypeEvacuationDto, TokenDto, ThemeDto, ParametreDto, ParametresJokerDto, ParametresRepresentantDto, TypeElementStockDto } from 'src/api/models';
import { AuthentificationService, CodesPostauxService, PanelService, ParcsService, PaysService, TypesConteneursMobilesService, TypesDechetsService, TypesDechetsRwService, UnitesMesureService, ZonesGeographiquesService, PictogrammesService, TypesIncidentsService, DocumentsService, CategoriesDocumentsService, RolesService, TypesAccesPersonnesMoralesService, FormesJuridiquesService, ExutoiresService, ConteneursService, ConteneursMobilesService, TransporteursService, DispatchExutoireService, DispatchTransporteurService, EmplacementsStockService, TypesEvacuationsService, ThemesService, TypesElementsStockService } from 'src/api/services';
import { pipe } from 'rxjs';
import { Router, PRIMARY_OUTLET } from '@angular/router';
import { ArticlesService } from 'src/api/services/articles.service';
import { ArticleDto } from 'src/api/models/article-dto';
import { LoaderService } from 'src/core/layouts/loader/loader.service';

declare var jwt_decode: any;

@State<ControlPanelState>({
  name: 'controlpanel',
  defaults: ControlPanelStateDefault,
})
@Injectable()
export class ControlPanelStore {

  isPermissionsReady: EventEmitter<any> = new EventEmitter();

  constructor(
    private notificationService: NotificationService,
    private translate: TranslateService,
    private panelService: PanelService,
    private codesPostauxService: CodesPostauxService,
    private paysService: PaysService,
    private typesDechetsService: TypesDechetsService,
    private typesDechetsRwService: TypesDechetsRwService,
    private unitesMesureService: UnitesMesureService,
    private parcsService: ParcsService,
    private exutoireService: ExutoiresService,
    private conteneurService: ConteneursService,
    private conteneursMobilesService: ConteneursMobilesService,
    private zonesGeographiquesService: ZonesGeographiquesService,
    private typesConteneursMobilesService: TypesConteneursMobilesService,
    private pictogrammesService: PictogrammesService,
    private categoriesDocumentsService: CategoriesDocumentsService,
    private authenticationService: AuthentificationService,
    private typesIncidentsService: TypesIncidentsService,
    private typeAccessPersonneMoraleService: TypesAccesPersonnesMoralesService,
    private formeJuridiqueService: FormesJuridiquesService,
    private transporteursService: TransporteursService,
    private dispatchExutoireService: DispatchExutoireService,
    private dispatchTransporteurService: DispatchTransporteurService,
    private emplacementsStockService: EmplacementsStockService,
    private articlesService: ArticlesService,
    private typeEvacuationsService: TypesEvacuationsService,
    private rolesService : RolesService,
    private themesService : ThemesService,
    private typesElementsStockService : TypesElementsStockService,
    private store: Store,
    private router: Router
  ) {
    this.isPermissionsReady.subscribe((res) => {
      if (res.route) {
        const route = this.router.parseUrl(res.route);
        return this.store.dispatch(new Navigate([route.root.children[PRIMARY_OUTLET].toString()], route.queryParams));
      } else {
        return res.fromCitoyen ? this.store.dispatch(new Navigate(['/citoyen/quota'])) : this.store.dispatch(new Navigate(['/dashboard']));
      }
    });
  }

  @Selector()
  static isLoggedIn$(state: ControlPanelState) {
    return state.isLoggedIn;
  }

  @Selector()
  static authToken$(state: ControlPanelState) {
    return state.token;
  }

  @Selector()
  static userName$(state: ControlPanelState) {
    return state.userName;
  }

  @Selector()
  static userId$(state: ControlPanelState) {
    return state.userId;
  }

  @Selector()
  static parcId$(state: ControlPanelState) {
    return state.parcId;
  }

  @Selector()
  static parc$(state: ControlPanelState) {
    return state.parc;
  }

  @Selector()
  static transporteurId$(state: ControlPanelState) {
    return state.transporteurId;
  }

  @Selector()
  static personnePhysiqueId$(state: ControlPanelState) {
    return state.personnePhysiqueId;
  }

  @Selector()
  static permissions$(state: ControlPanelState) {
    return state.permissions;
  }

  @Selector()
  static language$(state: ControlPanelState) {
    return state.language;
  }

  @Selector()
  static navigationItems$(state: ControlPanelState) {
    return state.navigation;
  }

  @Selector()
  static parametres$(state: ControlPanelState) {
    return state.allParams;
  }

  @Selector()
  static globalParams$(state: ControlPanelState) {
    return state.globalParams;
  }

  @Selector()
  static emailParams$(state: ControlPanelState) {
    return state.emailParams;
  }

  @Selector()
  static googleParams$(state: ControlPanelState) {
    return state.googleParams;
  }

  @Selector()
  static azureParams$(state: ControlPanelState) {
    return state.azureParams;
  }

  @Selector()
  static jokerParams$(state : ControlPanelState){
    return state.jokerParams;
  }

  @Selector()
  static representantParams$(state : ControlPanelState){
    return state.representantParams;
  }

  @Selector()
  static logo$(state: ControlPanelState) {
    return state.logo;
  }

  @Selector()
  static codesPostaux$(state: ControlPanelState) {
    return state.codesPostaux;
  }

  @Selector()
  static codesPostauxAcceptes$(state: ControlPanelState) {
    return state.codesPostauxAcceptes;
  }

  @Selector()
  static pays$(state: ControlPanelState) {
    return state.pays;
  }

  @Selector()
  static typesIncidents$(state: ControlPanelState) {
    return state.typesIncidents;
  }

  @Selector()
  static typesDechets$(state: ControlPanelState) {
    return state.typesDechets;
  }

  @Selector()
  static typesDechetsRW$(state: ControlPanelState) {
    return state.typesDechetsRW;
  }

  @Selector()
  static unitesMesure$(state: ControlPanelState) {
    return state.unitesMesure;
  }

  @Selector()
  static parcs$(state: ControlPanelState) {
    return state.parcs;
  }

  @Selector()
  static exutoires$(state: ControlPanelState) {
    return state.exutoires;
  }

  @Selector()
  static conteneurs$(state: ControlPanelState) {
    return state.conteneurs;
  }

  @Selector()
  static conteneursMobile$(state: ControlPanelState) {
    return state.conteneursMobile;
  }

  @Selector()
  static zonesGeographiques$(state: ControlPanelState) {
    return state.zonesGeographiques;
  }

  @Selector()
  static typesConteneursMobiles$(state: ControlPanelState) {
    return state.typesConteneursMobiles;
  }

  @Selector()
  static pictogrammes$(state: ControlPanelState) {
    return state.pictogrammes;
  }

  @Selector()
  static categoriesDocument$(state: ControlPanelState) {
    return state.categoriesDocument;
  }

  @Selector()
  static typesAcces$(state: ControlPanelState) {
    return state.typesAcces;
  }

  @Selector()
  static formesJuridiques$(state: ControlPanelState) {
    return state.formesJuridiques;
  }

  @Selector()
  static signalR$(state: ControlPanelState) {
    return state.signalR;
  }

  @Selector()
  static transporteurs$(state: ControlPanelState) {
    return state.transporteurs;
  }

  @Selector()
  static dispatchExutoires$(state: ControlPanelState) {
    return state.dispatchExutoires;
  }

  @Selector()
  static dispatchTransporteurs$(state: ControlPanelState) {
    return state.dispatchTransporteurs;
  }

  @Selector()
  static emplacements$(state: ControlPanelState) {
    return state.emplacements;
  }

  @Selector()
  static articles$(state: ControlPanelState) {
    return state.articles;
  }

  @Selector()
  static typesEvacuations$(state: ControlPanelState) {
    return state.typesEvacuations;
  }

  @Selector()
  static typesElementsStock$(state: ControlPanelState) {
    return state.typesElementsStock;
  }

  @Selector()
  static error$(state: ControlPanelState) {
    return state.error;
  }

  @Selector()
  static themes$(state: ControlPanelState) {
    return state.themes;
  }

  @Action(ControlPanel.Login)
  login({ patchState }: StateContext<ControlPanelState>, { authenticateDto }: ControlPanel.Login) {
    return this.authenticationService.authenticationAuthenticateWithJson({ body: authenticateDto }).pipe(
      tap((res: TokenDto) => {
        this.postLogin(res, patchState)
      }),
      catchError((error: Error) => {
        patchState({
          isLoggedIn: false,
          error: error.message,
          permissions: null,
          language: null,
          token: null,
          userName: null,
          userId: null
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.LoginPP)
  loginPP({ patchState }: StateContext<ControlPanelState>, { authenticateDto }: ControlPanel.LoginPP) {
    return this.authenticationService.authenticationAuthenticatePersonnePhysique({ body: authenticateDto }).pipe(
      tap((res: TokenDto) => {
        this.postLogin(res, patchState, true)
      }),
      catchError((error: Error) => {
        patchState({
          isLoggedIn: false,
          error: error.message,
          permissions: null,
          language: null,
          token: null,
          userName: null,
          userId: null,
          personnePhysiqueId: null
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.LoginFromCode)
  loginFromCode({ patchState }: StateContext<ControlPanelState>, { authenticateFromCodeDto }: ControlPanel.LoginFromCode) {
    return this.authenticationService.authenticationAuthenticateWithCode({ body: authenticateFromCodeDto }).pipe(
      tap((res: TokenDto) => {
        this.postLogin(res, patchState)
      }),
      catchError((error: Error) => {
        patchState({
          isLoggedIn: false,
          error: error.message,
          permissions: null,
          language: null,
          token: null,
          userName: null,
          userId: null
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.LoginFromMSAL)
  loginFromMSAL({ patchState }: StateContext<ControlPanelState>, { authenticateFromMsalDto }: ControlPanel.LoginFromMSAL) {
    return this.authenticationService.authenticationAuthenticateWithMsal({ body: authenticateFromMsalDto }).pipe(
      tap((res: TokenDto) => {
        this.postLogin(res, patchState)
      }),
      catchError((error: Error) => {
        patchState({
          isLoggedIn: false,
          error: error.message,
          permissions: null,
          language: null,
          token: null,
          userName: null,
          userId: null
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.LoginRedirect)
  loginRedirect({ getState, patchState }: StateContext<ControlPanelState>) {
    const state = getState();
    let authToken: TokenDto = { access_token: state.token };
    this.postLogin(authToken, patchState);
  }


  postLogin(res: TokenDto, patchState, fromCitoyen = false) {
    const decoded = jwt_decode(res.access_token);
    let roles = [];
    let userName;
    let userId;
    let parcId;
    let transporteurId;
    let personnePhysiqueId;
    let route = decoded.RouteParDefaut
    try {
      if (Array.isArray(decoded.role)) {
        roles = Array.from(decoded.role);
      } else {
        roles = [ decoded.role ];
      }
    } catch (error) { }
    try {
      userName = `${decoded.FirstName} ${decoded.LastName}`;
      userId = Number(decoded.Id);
      parcId = Number(decoded.ParcId);
      transporteurId = Number(decoded.TransporteurId);
      personnePhysiqueId = decoded.PersonnePhysiqueId;
    } catch (error) { }
    patchState({
      token: res.access_token,
      isLoggedIn: true,
      roles,
      permissions: [],
      userId,
      userName,
      personnePhysiqueId,
      parcId,
      transporteurId,
      error: null
    });

    if (parcId !== null && !isNaN(parcId)) {
      this.store.dispatch(new ControlPanel.GetUserParc(parcId));
    } else {
      this.store.dispatch(new ControlPanel.GetParcs());
    }
    let permissionsReady = roles.map(r => { return false });
    // Get permissions for role(s)
    roles.forEach((r, index) => this.store.dispatch(new ControlPanel.GetRolePermissions(r)).subscribe(() => {
      permissionsReady[index] = true;
      if(permissionsReady.filter(p => p).length == roles.length) {
        this.isPermissionsReady.next({route, fromCitoyen});
      }
    }));
  }

  @Action(ControlPanel.Logout)
  logout({ getState, setState }: StateContext<ControlPanelState>) {
    const state = getState();
    setState({
      ...state,
      userId: null,
      parcId: null,
      parc: null,
      transporteurId: null,
      userName: null,
      //token: null,
      navigation: [],
      parcs: null,
      isLoggedIn: false,
      permissions: [],
      roles: null
    });
  }

  @Action(ControlPanel.SetToken)
  setToken({ patchState }: StateContext<ControlPanelState>, { token }: ControlPanel.SetToken) {
    patchState({
      token: token
    });
  }

  @Action(ControlPanel.GetRolePermissions)
  getRolePermissions({getState, patchState}: StateContext<ControlPanelState>, { roleName }: ControlPanel.GetRolePermissions) {
    return this.rolesService.roleGetRolePermissions( { body: { Nom: roleName }}).pipe(
     tap((res: string[]) => {
        const state = getState();
        patchState({
          permissions: state.permissions.concat(res)
        });
      }),
      catchError((error: Error) => {
        patchState({
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetUserParc)
  getUserParc( { patchState }:StateContext<ControlPanelState>, { parcId }: ControlPanel.GetUserParc ) {
    return this.parcsService.parcGetDetail( { id: parcId }).pipe(
      tap((res: ParcDetailsDto) => {
        patchState({
          parc: res,
          error: null
        });
      }),
      catchError((error: Error) => {
        patchState({
          parc: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.ResetPassword)
  resetPassword({}: StateContext<ControlPanelState>, { token, newPassword }: ControlPanel.ResetPassword) {
    return this.authenticationService.authenticationSetPasswordWithToken({ body: { Token: token, NewPassword: newPassword } }).pipe(
      tap(() => {
        this.notificationService.displayMessage(
          TypeMessage.info,
          this.translate.instant('ResetPwdForm.Success'));
        this.store.dispatch(new Navigate(['/auth']));
      },
        (error: any) => {
          this.notificationService.displayMessage(
            TypeMessage.error, this
              .translate.instant('ResetPwdForm.Error'));
        })
    );
  }

  @Action(ControlPanel.ResetPasswordPersonnePhysique)
  resetPasswordPersonnePhysique({}: StateContext<ControlPanelState>, { token, newPassword }: ControlPanel.ResetPasswordPersonnePhysique) {
    return this.authenticationService.authenticationSetPersonnePhysiquePasswordWithToken({ body: { Token: token, NewPassword: newPassword } }).pipe(
      tap(() => {
        this.notificationService.displayMessage(
          TypeMessage.info,
          this.translate.instant('ResetPwdForm.Success'));
        this.store.dispatch(new Navigate(['/auth/login-citoyen']));
      },
        (error: any) => {
          this.notificationService.displayMessage(
            TypeMessage.error, this
              .translate.instant('ResetPwdForm.Error'));
        })
    );
  }

  @Action(ControlPanel.ChangePersonnePhysiquePassword)
  changePersonnePhysiquePassword({}: StateContext<ControlPanelState>, { login, changePasswordDto }: ControlPanel.ChangePersonnePhysiquePassword) {
    return this.authenticationService.authenticationChangePersonnePhysiquePassword({ login: login, body: changePasswordDto }).pipe(
      tap(() => {
        this.notificationService.displayMessage(
          TypeMessage.info,
          this.translate.instant('ResetPwdForm.Success'));
        this.store.dispatch(new Navigate(['/auth/login-citoyen']));
      },
        (error: any) => {
          this.notificationService.displayMessage(
            TypeMessage.error, this
              .translate.instant('ResetPwdForm.Error'));
        })
    );
  }

  @Action(ControlPanel.PasswordForgotten)
  passwordForgotten({}: StateContext<ControlPanelState>, { email }: ControlPanel.PasswordForgotten) {
    return this.authenticationService.authenticationAskPasswordReset({ body: { Email: email } }).pipe(
      tap((res) => {
        const msg = this.translate.instant('ForgotForm.Success');
        this.notificationService.displayMessage(TypeMessage.success, msg);
        this.router.navigate(['/']);
      })
    );
  }

  @Action(ControlPanel.GetNavigationMenu)
  getPanelSections({ getState, patchState }: StateContext<ControlPanelState>) {
    const state = getState();
    if (!state.isLoggedIn) { return null; }

    return this.panelService.panelGetMenuSections({ withItems: true }).pipe(
      tap((res: PanelSection[]) => {
        patchState({
          navigation: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetAllParams)
  getAllParams ({ patchState }: StateContext<ControlPanelState>) {
      return this.panelService.panelGetAllParams().pipe(
        tap((res: ParametreDto[]) => {
          patchState({
            allParams: res,
            error: null
          });
        }),
        catchError((error: Error) => {
        patchState({
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetGlobalParams)
  getGlobalParams({ patchState }: StateContext<ControlPanelState>) {
    return this.panelService.panelGetParams().pipe(
      tap((res: ParametresGlobauxDto) => {
        patchState({
          globalParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          globalParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.UpdateGlobalParams)
  updateGlobalParams({ patchState }: StateContext<ControlPanelState>, { params }: ControlPanel.UpdateGlobalParams) {
    return this.panelService.panelUpdateParams({ body: params }).pipe(
      tap((res: ParametresGlobauxDto) => {
        patchState({
          globalParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          globalParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetEmailParams)
  getEmailParams({ patchState }: StateContext<ControlPanelState>) {
    return this.panelService.panelGetEmail().pipe(
      tap((res: ParametresEmailDto) => {
        patchState({
          emailParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          emailParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.UpdateEmailParams)
  updateEmailParams({ patchState }: StateContext<ControlPanelState>, { params }: ControlPanel.UpdateEmailParams) {
    return this.panelService.panelUpdateEmail({ body: params }).pipe(
      tap((res: ParametresEmailDto) => {
        patchState({
          emailParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          emailParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetLogo)
  getLogo({ patchState }: StateContext<ControlPanelState>) {
    return this.panelService.panelGetLogo().pipe(
      tap((res: Blob) => {
        patchState({
          logo: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          logo: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetGoogleParams)
  getGoogleParams({ patchState }: StateContext<ControlPanelState>) {
    return this.panelService.panelGetGoogle().pipe(
      tap((res: ParametresGoogleDto) => {
        patchState({
          googleParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          googleParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.UpdateGoogleParams)
  updateGoogleParams({ patchState }: StateContext<ControlPanelState>, { params }: ControlPanel.UpdateGoogleParams) {
    return this.panelService.panelUpdateGoogle({ body: params }).pipe(
      tap((res: ParametresGoogleDto) => {
        patchState({
          googleParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          googleParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetAzureParams)
  getAzureParams({ patchState }: StateContext<ControlPanelState>) {
    return this.panelService.panelGetParamsAzure().pipe(
      tap((res: ParametresAzureDto) => {
        patchState({
          azureParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          azureParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.UpdateAzureParams)
  updateAzureParams({ patchState }: StateContext<ControlPanelState>, { params }: ControlPanel.UpdateAzureParams) {
    return this.panelService.panelUpdateParamsAzure({ body: params }).pipe(
      tap((res: ParametresAzureDto) => {
        patchState({
          azureParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          azureParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }



  @Action(ControlPanel.GetJokerParams)
  getJokerParams({ patchState }: StateContext<ControlPanelState>) {
    return this.panelService.panelGetJoker().pipe(
      tap((res: ParametresJokerDto) => {
        patchState({
          jokerParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          jokerParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.UpdateJokerParams)
  updateJokerParams({ patchState }: StateContext<ControlPanelState>, { params }: ControlPanel.UpdateJokerParams) {
    return this.panelService.panelUpdateJoker({ body: params }).pipe(
      tap((res: ParametresJokerDto) => {
        patchState({
          jokerParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          jokerParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetRepresentantParams)
  getRepresentantParams({ patchState }: StateContext<ControlPanelState>) {
    return this.panelService.panelGetRepresentant().pipe(
      tap((res: ParametresRepresentantDto) => {
        patchState({
          representantParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          representantParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.UpdateRepresentantParams)
  updateRepresentantParams({ patchState }: StateContext<ControlPanelState>, { params }: ControlPanel.UpdateRepresentantParams) {
    return this.panelService.panelUpdateRepresentant({ body: params }).pipe(
      tap((res: ParametresRepresentantDto) => {
        patchState({
          representantParams: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          representantParams: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetCodesPostaux)
  getCodesPostaux({ patchState, dispatch }: StateContext<ControlPanelState>) {
    return this.codesPostauxService.codePostalGetList().pipe(
      tap((res: CodePostalDto[]) => {
        patchState({
          codesPostaux: res
        });
        dispatch(new ControlPanel.GetCodesPostauxAcceptes()); // Refresh accepted at the same time
      }),
      catchError((error: Error) => {
        patchState({
          codesPostaux: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetCodesPostauxAcceptes)
  getCodesPostauxAcceptes({ patchState }: StateContext<ControlPanelState>) {
    return this.codesPostauxService.codePostalGetListAcceptes().pipe(
      tap((res: CodePostalDto[]) => {
        patchState({
          codesPostauxAcceptes: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          codesPostauxAcceptes: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetPays)
  getPays({ patchState }: StateContext<ControlPanelState>) {
    return this.paysService.paysGetList().pipe(
      tap((res: PaysDto[]) => {
        patchState({
          pays: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          pays: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetTypesIncidents)
  getTypesIncidents({ patchState }: StateContext<ControlPanelState>) {
    return this.typesIncidentsService.typeIncidentGetList().pipe(
      tap((res: TypeIncidentDto[]) => {
        patchState({
          typesIncidents: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          typesIncidents: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetTypesDechet)
  getTypesDechet({ patchState }: StateContext<ControlPanelState>) {
    return this.typesDechetsService.typeDechetGetList().pipe(
      tap((res: TypeDechetDto[]) => {
        patchState({
          typesDechets: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          typesDechets: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetTypesDechetRW)
  getTypesDechetRW({ patchState }: StateContext<ControlPanelState>) {
    return this.typesDechetsRwService.typeDechetRwGetList().pipe(
      tap((res: TypeDechetRwdto[]) => {
        patchState({
          typesDechetsRW: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          typesDechetsRW: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetUnitesMesure)
  getUnitesMesure({ patchState }: StateContext<ControlPanelState>) {
    return this.unitesMesureService.uniteMesureGetList().pipe(
      tap((res: UniteMesureDto[]) => {
        patchState({
          unitesMesure: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          unitesMesure: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetParcs)
  getParcs({ patchState }: StateContext<ControlPanelState>) {
    return this.parcsService.parcGetList().pipe(
      tap((res: ParcDto[]) => {
        patchState({
          parcs: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          parcs: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetExutoires)
  getExutoires({ patchState }: StateContext<ControlPanelState>) {
    return this.exutoireService.exutoireGetList().pipe(
      tap((res: ExutoireDto[]) => {
        patchState({
          exutoires: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          exutoires: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetConteneurs)
  getConteneurs({ patchState }: StateContext<ControlPanelState>) {
    return this.conteneurService.conteneurGetList().pipe(
      tap((res: ConteneurDto[]) => {
        patchState({
          conteneurs: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          conteneurs: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetConteneursMobiles)
  getConteneursMobiles({ patchState }: StateContext<ControlPanelState>) {
    return this.conteneursMobilesService.conteneurMobileGetList().pipe(
      tap((res: ConteneurDto[]) => {
        patchState({
          conteneursMobile: res
        });
      }),
      catchError((error: Error) => {
        patchState({
          conteneursMobile: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetZonesGeographiques)
  getZonesGeographiques({ patchState }: StateContext<ControlPanelState>) {
    return this.zonesGeographiquesService.zoneGeographiqueGetList().pipe(
      tap((res: ZoneGeographiqueDto[]) => {
        patchState({
          zonesGeographiques: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          zonesGeographiques: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetTypesConteneurs)
  getTypesConteneurs({ patchState }: StateContext<ControlPanelState>) {
    return this.typesConteneursMobilesService.typeConteneurMobileGetList().pipe(
      tap((res: TypeConteneurMobileDto[]) => {
        patchState({
          typesConteneursMobiles: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          typesConteneursMobiles: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetPictogrammes)
  getPictogrammes({ patchState }: StateContext<ControlPanelState>) {
    return this.pictogrammesService.pictogrammesGetList().pipe(
      tap((res: PictogrammeDto[]) => {
        patchState({
          pictogrammes: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          pictogrammes: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetCategoriesDocuments)
  getDocuments({ patchState }: StateContext<ControlPanelState>) {
    return this.categoriesDocumentsService.categorieDocumentGetList().pipe(
      tap((res: CategorieDocumentDto[]) => {
        patchState({
          categoriesDocument: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          categoriesDocument: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.UpdateSignalRStatus)
  updateSignalRStatus({ patchState }: StateContext<ControlPanelState>, { status }: ControlPanel.UpdateSignalRStatus) {
    patchState({
      signalR: status
    });
  }

  @Action(ControlPanel.GetTypesAcces)
  getTypesAcces( { patchState}: StateContext<ControlPanelState>) {
    return this.typeAccessPersonneMoraleService.typeAccesPersonneMoraleGetList().pipe(
      tap((res: TypeAccesPersonneMoraleDto[]) => {
        patchState({
          typesAcces: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          typesAcces: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetFormesJuridiques)
  getFormesJuridiques( { patchState}: StateContext<ControlPanelState>) {
    return this.formeJuridiqueService.formeJuridiqueGetList().pipe(
      tap((res: FormeJuridiqueDto[]) => {
        patchState({
          formesJuridiques: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          formesJuridiques: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetTransporteurs)
  getTransporteurs( { patchState}: StateContext<ControlPanelState>) {
    return this.transporteursService.transporteurGetList().pipe(
      tap((res: TransporteurDto[]) => {
        patchState({
          transporteurs: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          transporteurs: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetDispatchExutoires)
  getDispatchExutoires( {patchState}: StateContext<ControlPanelState>) {
    return this.dispatchExutoireService.dispatchExutoireGetListActifs().pipe(
      tap((res: DispatchExutoireDto[]) => {
        patchState({
          dispatchExutoires: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          dispatchExutoires: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetDispatchTransporteurs)
  getDispatchTransporteurs( {patchState}: StateContext<ControlPanelState>) {
    return this.dispatchTransporteurService.dispatchTransporteurGetListActifs().pipe(
      tap((res: DispatchTransporteurDto[]) => {
        patchState({
          dispatchTransporteurs: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          dispatchTransporteurs: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetEmplacements)
  getEmplacements( {patchState}: StateContext<ControlPanelState>) {
    return this.emplacementsStockService.emplacementStockGetList().pipe(
      tap((res: EmplacementStockDto[]) => {
        patchState({
          emplacements: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          emplacements: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetArticles)
  getArticles( {patchState}: StateContext<ControlPanelState>) {
    return this.articlesService.articleGetList().pipe(
      tap((res: ArticleDto[]) => {
        patchState({
          articles: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          articles: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetTypesEvacuations)
  getTypesEvacuations( { patchState }: StateContext<ControlPanelState>) {
    return this.typeEvacuationsService.typeEvacuationGetList().pipe(
      tap( (res: TypeEvacuationDto[]) => {
        patchState({
          typesEvacuations: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          typesEvacuations: null,
          error: error.message
        });
        return of(error);
      })
    )
  }

  @Action(ControlPanel.GetThemes)
  getThemes({ patchState }: StateContext<ControlPanelState>) {
    return this.themesService.themeGetList().pipe(
      tap((res: ThemeDto[]) => {
        patchState({
          themes: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          themes: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(ControlPanel.GetTypesElementsStock)
  getTypesElementsStock({ patchState }: StateContext<ControlPanelState>) {
    return this.typesElementsStockService.typeElementStockGetListActifs().pipe(
      tap((res: TypeElementStockDto[]) => {
        patchState({
          typesElementsStock: res,
          error: null,
        });
      }),
      catchError((error: Error) => {
        patchState({
          typesElementsStock: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

}
